document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-coaching-package]');
  if (!link) return;
  const select = document.getElementById('CoachingPackage');
  if (!select) return;
  const option = Array.from(select.options).find(function (item) { return item.value === link.dataset.coachingPackage; });
  if (!option) return;
  select.value = option.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('change', function (event) {
  if (event.target.id !== 'CoachingPackage') return;
  const status = document.querySelector('.lm-package-selection');
  if (status) status.textContent = event.target.value === 'Help me choose' ? 'We’ll help you find the right level of support.' : event.target.value + ' selected. Complete your application below — no payment is taken here.';
});
